import { doGraphqlRequest } from 'ducks/requests'
import { SETTINGS_INTEGRATIONS_PROVIDER_PAGE } from 'subapps/settings/types'
import * as types from '../types'
import { selectIsFullyLoaded } from '../selectors/base'

export {
  default as doFetchIntegrationSettings,
} from './doFetchIntegrationSettings'
export {
  default as doSaveIntegrationSettings,
} from './doSaveIntegrationSettings'
export {
  default as doFetchExternalResourcesForNewActions,
} from './doFetchExternalResourcesForNewActions'

const removeIntegrationMutation = `
  mutation RemoveIntegration(
    $id: ID!,
  ){
    deleteIntegration(
      id: $id
    ) {
      id

    }
  }
`

export const doRemoveIntegration = id => dispatch => {
  const variables = { id }
  dispatch(
    doGraphqlRequest(
      types.REMOVE_INTEGRATION,
      removeIntegrationMutation,
      variables,
      {
        meta: { integrationId: id },
        transformResponse: data => data.deleteIntegration,
      }
    )
  )
}
const addShopifyMutation = `
  mutation AddShopifyStore(
    $apiKey: String!,
    $apiPassword: String!,
    $storeName: String!,
    $storeDomain: String!,
  ){
    addShopifyStore(
      apiKey: $apiKey,
      apiPassword: $apiPassword,
      storeName: $storeName,
      storeDomain: $storeDomain,
    ) {
      id
    }
  }
`

export const doAddShopifyStore = params => dispatch =>
  dispatch(
    doGraphqlRequest(types.ADD_SHOPIFY_STORE, addShopifyMutation, params)
  )

const updateShopifyMutation = `
  mutation UpdateShopifyStore(
    $id: ID!,
    $apiKey: String,
    $apiPassword: String,
    $storeName: String!,
    $storeDomain: String!,
  ){
    updateShopifyStore(
      id: $id,
      apiKey: $apiKey,
      apiPassword: $apiPassword,
      storeName: $storeName,
      storeDomain: $storeDomain,
    ) {
      id
    }
  }
`
export const doUpdateShopifyStore = params => dispatch =>
  dispatch(
    doGraphqlRequest(types.EDIT_SHOPIFY_STORE, updateShopifyMutation, params)
  )

const fetchIntegrationsMutation = `
  query IntegrationsQuery {
    user {
      integrations {
        id
        provider
        kind
        mailboxId
        storeName
        storeDomain
        username
        url
      }
    }
  }
`

export const doFetchIntegrations = () => (dispatch, getState) => {
  const state = getState()
  if (selectIsFullyLoaded(state)) return
  // eslint-disable-next-line consistent-return
  return dispatch(
    doGraphqlRequest(types.FETCH_INTEGRATIONS, fetchIntegrationsMutation)
  )
}

export const doOpenProviderPage = provider => () => dispatch => {
  dispatch({ type: SETTINGS_INTEGRATIONS_PROVIDER_PAGE, payload: { provider } })
}
